// Fetch-Wrapper für unsere eigenen /api/*-Endpoints.
// Hängt aktuellen Supabase-JWT als Bearer-Token automatisch ran.

import { supabase } from "@/lib/supabase";

export async function apiGet<T = unknown>(path: string): Promise<T> {
  return apiFetch<T>(path, { method: "GET" });
}

export async function apiPost<T = unknown>(path: string, body: unknown): Promise<T> {
  return apiFetch<T>(path, {
    method: "POST",
    body: JSON.stringify(body),
    headers: { "Content-Type": "application/json" },
  });
}

async function apiFetch<T>(path: string, init: RequestInit): Promise<T> {
  const { data } = await supabase.auth.getSession();
  const headers = new Headers(init.headers);
  if (data.session?.access_token) {
    headers.set("Authorization", `Bearer ${data.session.access_token}`);
  }
  const res = await fetch(path, { ...init, headers });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`API ${res.status}: ${txt.slice(0, 300)}`);
  }
  return res.json();
}

export interface GeocodeResult {
  lat: number;
  lng: number;
  display_name: string;
  distance_km: number;
  in_delivery_zone: boolean;
  cached: boolean;
}

export function geocode(q: string): Promise<GeocodeResult> {
  return apiGet<GeocodeResult>(`/api/geocode?q=${encodeURIComponent(q)}`);
}
